<template>
  <div class="content">

    <div class="center" v-if="!orderId">

      <div class="detail-box">
        <div class="device-box flex-row">
          <div class="device-img">
            <img :src="$imgUrl + info.pictureUrl" />
          </div>
          <div class="device-info">
            <p class="name">{{ info.title }}</p>
            <div class="price-box flex-row">
              <span>价格</span>
              <span class="price"
                >￥{{ info.priceGears && info.priceGears.price }}/3月</span
              >
            </div>
            <p class="tips">
              *价格说明<br />
              以上价格标注为参考价，具体价格您根据需求下单后待双方协商
            </p>
            <div class="info">
              <div class="title">
                <p>设备信息</p>
              </div>
              <div class="info-intro flex-row info-intro2">
                <div class="item">
                  <label>提供人姓名</label> <span>{{ info.userName }}</span>
                </div>
                <div class="item">
                  <label>设备类型</label> <span>{{ info.typeName }}</span>
                </div>
                <div class="item">
                  <label>设备容量</label> <span>{{ info.volume }}</span>
                </div>
                <div class="item">
                  <label>设备地点</label>
                  <span>{{
                    info.provinceName + info.cityName + info.countyName
                  }}</span>
                </div>
                <div class="item">
                  <label>输出电压</label> <span>{{ info.voltage }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="btns">
            <button class="apply" @click="openCustomerServer">在线留言</button>
            <br />
            <button class="service" @click="customerServer">联系客服</button>
          </div>
        </div>

        <div class="intro-box">
          <div class="title">配套线路：</div>
          <div class="service-plan flex-row">
            <div class="item">
              <label>架空线路：</label>
              <span>{{ info.priceGears && info.priceGears.jkxl }}元/档</span>
            </div>
            <div class="item">
              <label>电缆线路：</label>
              <span>{{ info.priceGears && info.priceGears.dlxl }}元/米</span>
            </div>
            <div class="item">
              <label>单杆：</label>
              <span>{{ info.priceGears && info.priceGears.dgxl }}元/个</span>
            </div>
            <div class="" style="margin-left: 20px">
              标准档距：50米/档，现场勘查时不足50米按一档计；相关设备以及线路占地用户负责协调
            </div>
          </div>
        </div>
      </div>

      <div class="order">
        <div class="order-info flex-row">
          <div class="left">
              <p class="tit1">*工程名称</p>
              <div class="address flex-row"  style="margin-bottom: 70px">
                  <el-input v-model="projectname"
                            placeholder="请填写工程名称"
                            >

                  </el-input>
              </div>
            <p class="tit1">地址信息</p>
            <div class="address flex-row">
              <el-select
                v-model="addressVal"
                placeholder="请选择地址"
                size="medium"
              >
                <el-option
                  v-for="(item, index) in addressList"
                  :key="item.id"
                  :label="
                    item.provinceName +
                      '-' +
                      item.cityName +
                      '-' +
                      item.countyName +
                      ' ' +
                      item.address
                  "
                  :value="
                    item.provinceName +
                      item.cityName +
                      item.countyName +
                      item.address
                  "
                >
                </el-option>
              </el-select>
            </div>
            <p class="tit2">*开始时间</p>
            <el-date-picker
              class="date"
              v-model="form.startTime"
              type="date"
              placeholder="选择日期"
              size="medium"
              value-format="yyyy-MM-dd"
              clearable
            >
            </el-date-picker>
            <p class="tips">结束时间为次日开始时间的日期</p>
          </div>
          <div class="right">
            <p class="tit3">
              租赁期限<span
                >*不包含施工费用，最终价格需要厂商勘察现场后确认。</span
              >
            </p>
            <div class="term-list flex-row">
              <div
                :class="['item', { active: termNum == index }]"
                v-for="(item, index) in termList"
                @click="monthHandle(item, index)"
              >
                <p>{{ item.month }}月</p>
                <p>￥{{ item.price }}</p>
                <em></em>
              </div>
            </div>
            <div class="num-list flex-row">
              <div class="item">
                <p>
                  单杆：<span
                    >{{ info.priceGears && info.priceGears.dgxl }}元/个</span
                  >
                </p>
                <el-input-number
                  v-model="form.dgxlNum"
                  @change="handleChange"
                  :min="0"
                  :max="1"
                  label="描述文字"
                >
                </el-input-number>
              </div>
              <div class="item">
                <p>
                  架空线路：<span
                    >{{ info.priceGears && info.priceGears.jkxl }}元/档</span
                  >
                </p>
                <el-input-number
                  v-model="form.jkxlNum"
                  @change="handleChange"
                  :min="0"
                  :max="100"
                  label="描述文字"
                >
                </el-input-number>
              </div>
              <div class="item">
                <p>
                  电缆线路：<span
                    >{{ info.priceGears && info.priceGears.dlxl }}元/米</span
                  >
                </p>
                <el-input-number
                  v-model="form.dlxlNum"
                  @change="handleChange"
                  :min="0"
                  :max="100"
                  label="描述文字"
                >
                </el-input-number>
              </div>
            </div>
          </div>
        </div>
        <div class="bot flex-row">
          <p class="price">
            合计<span>￥{{ form.advance.toFixed(2) }}</span>
          </p>
          <button class="apply" @click="submit(1)" v-if="orderId == null">
            提交申请
          </button>
          <button class="saveOrder" @click="submit(0)" v-if="orderId == null">
            保存订单
          </button>
          <button class="apply" @click="submit1(1)" v-if="orderId != null">
            提交申请
          </button>
          <button class="saveOrder" @click="submit2(1)" v-if="orderId != null">
            删除订单
          </button>
          <button class="saveOrder" @click="changeEq" v-if="orderId != null">
            修改设备
          </button>
        </div>
      </div>
    </div>
    <div class="center" v-if="orderId">
        <div class="detail-top flex-row">
            <div class="title">当前状态：
                {{info.orderSatus == 0 ? '未确认提交': info.orderSatus == 1 ? '待厂商确认' : info.orderSatus == 2 ? '待平台签约'
                  : info.orderSatus == 3 ? '待客户支付租金' : info.orderSatus == 24 ? '待厂商支付服务费'
                      : info.orderSatus == 34 ? '待平台确认服务费': info.orderSatus == 5 ? '待厂商安装验收'
                          : info.orderSatus == 6 ? '待客户用电完成' : info.orderSatus == 7 ? '已完成'
                              : info.orderSatus == 8 ? '已完成(已评价)' : info.orderSatus == 70 ? '中止订单' : '其他'}}
            </div>

            <!--            <button class="saveOrder" @click="submit2(1)" v-if="orderId != null">-->
            <!--                中止订单-->
            <!--            </button>-->
            <el-button class="btn" plain @click="deleteOrder()" v-if="orderId != null&&info.orderSatus==0">
                删除订单
            </el-button>
            <el-button
                    class="btn"
                    plain
                    v-show="orderId != null"
                    @click="submit2(1)"
            >中止订单</el-button>
            <!--            <el-button class="btn" plain v-show="statusId == 6" @click="songdian()"-->
            <!--            >确认送电</el-button>-->
            <el-button class="btn" plain @click="customerServer"
            >联系客服</el-button>
        </div>

      <!-- <div class="header">
				<span>{{info.serviceType == 0 ? '成套设备合并订单' : '保电设备合并订单'}}</span>
				<el-button size="medium" type="warning" @click="customerServer">联系客服</el-button>
			</div> -->
      <div class="detail-box" v-for="(item, index) in eqList" :key="index">
        <div class="device-box flex-row">
          <div class="device-img">
            <img :src="$imgUrl + item.pictureUrl" />
          </div>
          <div class="device-info">
            <p class="name">{{ item.title }}</p>
            <div class="price-box flex-row">
              <span>价格</span>
              <span class="price"
                >￥{{ item.priceGears && item.priceGears.price }}/3月</span
              >
            </div>
            <p class="tips">
              *价格说明<br />
              以上价格标注为参考价，具体价格您根据需求下单后待双方协商
            </p>
          </div>
          <div class="info">
            <div class="title">
              <p>设备信息</p>
            </div>
            <div class="info-intro">
              <div class="item">
                <label>提供人姓名</label>
                <span>{{ item.userName }}</span>
              </div>
              <div class="item">
                <label>设备类型</label> <span>{{ item.typeName }}</span>
              </div>
              <div class="item">
                <label>设备容量</label> <span>{{ item.volume }}</span>
              </div>
              <div class="item">
                <label>设备地点</label>
                <span>{{
                  item.provinceName + item.cityName + item.countyName
                }}</span>
              </div>
              <div class="item">
                <label>输出电压</label> <span>{{ item.voltage }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="intro-box">
          <div class="title">配套线路：</div>
          <div class="service-plan flex-row">
            <div class="item">
              <label>架空线路：</label>
              <span>{{ item.priceGears && item.priceGears.jkxl }}元/档</span>
            </div>
            <div class="item">
              <label>电缆线路：</label>
              <span>{{ item.priceGears && item.priceGears.dlxl }}元/米</span>
            </div>
            <div class="item">
              <label>单杆：</label>
              <span>{{ item.priceGears && item.priceGears.dgxl }}元/个</span>
            </div>
            <div class="" style="font-size: 14px; margin-left: 20px">
              标准档距：50米/档，现场勘查时不足50米按一档计；相关设备以及线路占地用户负责协调
            </div>
          </div>
        </div>

        <div class="num-list flex-row">
          <div class="item">
            <p>
              架空线路：<span
                >{{ item.priceGears && item.priceGears.jkxl }}元/档</span
              >
            </p>
            <el-input-number
              v-model="item.dsbjkxl"
              @change="getSimTotal"
              :min="0"
              :max="100"
              label="描述文字"
            >
            </el-input-number>
          </div>
          <div class="item">
            <p>
              电缆线路：<span
                >{{ item.priceGears && item.priceGears.dlxl }}元/米</span
              >
            </p>
            <el-input-number
              v-model="item.dsbdlxl"
              @change="getSimTotal"
              :min="0"
              :max="100"
              label="描述文字"
            >
            </el-input-number>
          </div>
          <div class="item">
            <p>
              单杆：<span
                >{{ item.priceGears && item.priceGears.dgxl }}元/个</span
              >
            </p>
            <el-input-number
              v-model="item.dsbdgxl"
              @change="getSimTotal"
              :min="0"
              :max="1"
              label="描述文字"
            >
            </el-input-number>
          </div>
        </div>
      </div>
      <!-- 订单项 -->
      <div class="order">
        <div class="order-info flex-row">
          <div class="left">
              <p class="tit1">*工程名称</p>
              <div class="address flex-row" style="margin-bottom: 70px">
                  <el-input v-model="projectname"
                            placeholder="请填写工程名称"
                            >

                  </el-input>
              </div>
            <p class="tit1">地址信息</p>
            <div class="address flex-row">
              <el-select
                v-model="addressVal"
                placeholder="请选择地址"
                size="medium"
              >
                <el-option
                  v-for="(item, index) in addressList"
                  :key="item.id"
                  :label="
                    item.provinceName +
                      '-' +
                      item.cityName +
                      '-' +
                      item.countyName +
                      ' ' +
                      item.address
                  "
                  :value="
                    item.provinceName +
                      item.cityName +
                      item.countyName +
                      item.address
                  "
                >
                </el-option>
              </el-select>
            </div>
            <p class="tit2">*开始时间</p>
            <el-date-picker
              class="date"
              v-model="form.startTime"
              type="date"
              placeholder="选择日期"
              size="medium"
              value-format="yyyy-MM-dd"
              clearable
            >
            </el-date-picker>
            <p class="tips">结束时间为次日开始时间的日期</p>
          </div>
          <div class="right">
            <p class="tit3">
              租赁期限<span
                >*不包含施工费用，最终价格需要厂商勘察现场后确认。</span
              >
            </p>
            <div class="term-list flex-row">
              <div
                :class="['item', { active: termNum == index }]"
                v-for="(item, index) in termList"
                @click="monthHandle2(item, index)"
              >
                <p>{{ item.month }}月</p>
                <p>￥{{ item.price }}</p>
                <p>{{ item.priceStr }}</p>
                <em></em>
              </div>
            </div>
          </div>
        </div>
        <div class="bot flex-row">
          <p class="price">
            合计<span>￥{{ parseFloat(form.advance) + getSimTotal() }}</span>
          </p>
          <button class="apply" @click="submit11(1)">提交订单</button>
<!--          <button class="saveOrder" @click="submit2(1)" v-if="orderId != null">-->
<!--            中止订单-->
<!--          </button>-->
<!--            <button class="saveOrder" @click="deleteOrder()" v-if="orderId != null&&info.orderSatus==0">-->
<!--                删除订单-->
<!--            </button>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RelatedCompany from "@/components/ordinary/relatedCompany.vue";
import axios from "axios";
import {
  equipmentDetailApi,
  addOrderApi,
  adderssList,
  orderDetailApi,
  updateCarOrder,
  eqPriceListApi,
} from "../../http/api/ordinary.js";
import { updateOrder, delOrder } from "../../http/factory/add-eme.js";
import serverConfig from "@/http/config";
export default {
  components: {
    RelatedCompany,
  },
  data() {
    return {
      num: 1,
      moreShow: false,
      activeNum: 0,
      termNum: 0,
      termList: [
        {
          month: "3",
          price: "20000",
        },
        {
          month: "6",
          price: "40000",
        },
        {
          month: "9",
          price: "50000",
        },
        {
          month: "12",
          price: "80000",
        },
      ],
      num1: 0,
      num2: 0,
      num3: 0,
      date: "",
      info: {},
      form: {
        orderSatus: null,
        userAddress: "",
        startTime: null,
        orderType: 0,
        businessId: null,
        equipmentId: null,
        advance: 0,
        dgxlNum: 0,
        dgxlPrice: 0,
        jkxlNum: 0,
        jkxlPrice: 0,
        dlxlNum: 0,
        dlxlPrice: 0,
        //月份
        month: "",
        price: 0,
      },
      addressList: [],
        projectname:null,
      addressVal: "",
      id: null, //设备id，单设备
      orderId: null,
      eqList: [],
      ids: [],
    };
  },
  created() {
    if (this.$route.query.id != undefined) {
      this.id = this.$route.query.id;
      this.getDetail();
    }
    if (this.$route.query.orderId != undefined) {
      this.orderId = this.$route.query.orderId;
      this.getOrderDetail();
    }
    this.getAddress();
  },
  methods: {
    changeEq() {
      let obj = {
        id: this.info.businessId,
        name: this.info.companyName,
        heading: this.info.pictureUrl,
      };

      this.$router.push({
        path: "/ordinaryUser/companyEme",
        query: {
          object: JSON.stringify(obj),
          changeEq: this.orderId,
        },
      });
    },
    submit2() {
        this.$confirm("您确认要中止当前订单吗", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(() => {
            updateOrder({
                id: this.orderId,
                orderSatus: 70,
                zzddTime: this.formatTime(),
            }).then((res) => {
                this.$message({
                    message: "中止成功",
                    type: "warning",
                    onClose: () => {
                        this.$router.back();
                    },
                });
            });
        });
    },
    getOrderDetail() {
      orderDetailApi({
        id: this.orderId,
      }).then((res) => {
        if (this.id) {
          this.getDetail1(res.equipmentId);
        }
        this.termNum = parseInt(res.orderPro.duration) / 3 - 1;
        this.info = res;
        this.addressVal = res.userAddress;
          this.projectname = res.projectname;
        this.form.startTime = res.startTime;
        this.form.dgxlNum = res.orderPro.dgxlNum;
        this.form.jkxlNum = res.orderPro.jkxlNum;
        this.form.dlxlNum = res.orderPro.dlxlNum;
        this.eqList = JSON.parse(res.equipmentList);
        if (this.eqList.length == 1) {
          this.eqList[0].dsbdgxl = res.orderPro.dgxlNum;
          this.eqList[0].dsbjkxl = res.orderPro.jkxlNum;
          this.eqList[0].dsbdlxl = res.orderPro.dlxlNum;
        }
        for (let item of this.eqList) {
          console.log("item", item);
          this.ids.push(item.id);
        }
        console.log("ids", this.ids);
        this.getEqPriceList();

      });
    },
    getEqPriceList() {
      eqPriceListApi({
        equipmentIds: this.ids.join(","),
      }).then((res) => {
        this.termList = res;
        this.termList.forEach(function(item) {
          item.month = item.day;
        });
        this.getPricFlag = false;
        this.form.advance = this.termList[this.termNum].price;
      });
    },
    getDetail1(id) {
      equipmentDetailApi({
        id: id,
      }).then((res) => {
        this.info = res;
        let obj = res.priceGears;
        this.termList[0].price = obj.price;
        this.termList[1].price = obj.price1;
        this.termList[2].price = obj.price2;
        this.termList[3].price = obj.price3;
        //将三月分赋值
        this.form.month = this.termList[0].month;
        this.form.price = this.termList[0].price;
        this.computePrice();
      });
    },
    getAddress() {
      adderssList({}).then((res) => {
        this.addressList = res.rows;
      });
    },
    customerServer() {
      this.$router.push({
        path: "/service",
      });
    },
    openCustomerServer() {
      this.$router.push({
        path: "/service",
        query: {
          contactType: 1,
          contactId: this.info.customerId,
        },
      });
    },
    getDetail() {
      equipmentDetailApi({
        id: this.$route.query.id,
      }).then((res) => {
        this.info = res;
        let obj = res.priceGears;
        this.termList[0].price = obj.price;
        this.termList[1].price = obj.price1;
        this.termList[2].price = obj.price2;
        this.termList[3].price = obj.price3;
        //将三月分赋值
        this.form.month = this.termList[0].month;
        this.form.price = this.termList[0].price;
        this.computePrice();
      });
    },
    handleChange() {
      this.computePrice();
    },
    computePrice() {
      this.form.advance =
        this.form.price +
        this.info.priceGears.dgxl * this.form.dgxlNum +
        this.info.priceGears.jkxl * this.form.jkxlNum +
        this.info.priceGears.dlxl * this.form.dlxlNum;
    },
    submit(type) {
        if (this.projectname == null) {
            return this.$message("请填写工程名称");
        }
      if (this.form.startTime == null) {
        return this.$message("请选择开始时间");
      }
      this.$confirm(
        `您确认要${type == 1 ? "申请" : "保存"}当前订单吗`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.form.userAddress = this.addressVal;
          this.form.projectname = this.projectname;
        this.form.equipmentId = this.info.id;
        this.form.businessId = this.info.customerId;
        this.form.orderSatus = type;
        this.form.orderPro = {
          duration: this.form.month,
          dgxlNum: this.form.dgxlNum,
          jkxlNum: this.form.jkxlNum,
          dlxlNum: this.form.dlxlNum,
        };
        addOrderApi(this.form).then((res) => {
          this.$message({
            type: "success",
            message: "创建成功",
          });
          this.$router.push({
            path: "/personalCenter/orderDevice",
          });
        });
      });
    },
    submit1(type) {
        if (this.projectname == null) {
            return this.$message("请填写工程名称");
        }
      if (this.form.startTime == null) {
        return this.$message("请选择开始时间");
      }
      this.$confirm(
        `您确认要${type == 1 ? "申请" : "保存"}当前订单吗`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.form.id = this.orderId;
        this.form.userAddress = this.addressVal;
          this.form.projectname = this.projectname;
        this.form.businessId = this.info.customerId;
        this.form.orderSatus = type;
        this.form.orderPro = {
          duration: this.form.month,
          dgxlNum: this.form.dgxlNum,
          jkxlNum: this.form.jkxlNum,
          dlxlNum: this.form.dlxlNum,
        };
        updateOrder(this.form).then((res) => {
          this.$message({
            type: "success",
            message: "创建成功",
          });
          this.$router.push({
            path: "/personalCenter/orderDevice",
          });
        });
      });
    },
    monthHandle(item, index) {
      this.termNum = index;
      (this.form.month = item.month), (this.form.price = item.price);
      this.computePrice();
    },
    //多设备
    submit11(type) {
        if (this.projectname == null) {
            return this.$message("请填写工程名称");
        }
      if (this.form.startTime == null) {
        return this.$message("请选择开始时间");
      }
      this.$confirm(
        `您确认要${type == 1 ? "申请" : "保存"}当前订单吗`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        let aa = this.form.advance;
        let bb = this.getSimTotal();
        this.form.advance = parseFloat(aa) + parseFloat(bb);
        console.log(this.form.advance);
        this.form.userAddress = this.addressVal;
          this.form.projectname = this.projectname;
        this.form.businessId = this.eqList[0].customerId;
        this.form.orderSatus = type;
        this.form.orderType = 0;
        this.form.orderPro = {
          duration: this.termList[this.termNum].month,
        };
        axios({
          method: "post",
          url: serverConfig.baseURL+"/api/Master/updateOrderMonth",//"http://localhost:8080/api/Master/updateOrderMonth",
          data: {
            id: this.orderId,
            duration: this.form.month,
          },
          header: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }).then((response) => {
          console.log(response.data);
        });
        this.form.fuwuFangan = this.eqList;
        this.form.id = this.orderId;
        updateCarOrder(this.form).then((res) => {
          this.$message({
            type: "success",
            message: "创建成功",
          });
          this.$router.push({
            path: "/personalCenter/orderDevice",
          });
        });
      });
    },
    //多设备
    monthHandle2(item, index) {
      console.log(11111);
      this.termNum = index;
      this.form.month = this.termList[this.termNum].day;
      this.form.advance = this.termList[this.termNum].price;
    },
    //多设备计算
    getSimTotal() {
      let total = 0;
      for (let item of this.eqList) {
        total +=
          item.dsbjkxl * item.priceGears.jkxl +
          item.dsbdlxl * item.priceGears.dlxl +
          item.dsbdgxl * item.priceGears.dgxl;
      }
      return total;
    },
    //多设备
    //删除订单
    deleteOrder() {

        this.$confirm('你确定要删除当前订单吗', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {

            delOrder({
                id: this.orderId,
            }).then((res) => {
                this.$message({
                    message: "删除成功",
                    type: "warning",
                    onClose: () => {
                        this.$router.back();
                    },
                });
            });



        })

    },
  },
};
</script>

<style scoped lang="less">
.content {
  font-size: 0.14rem;
  background: #f5f5f5;

  .btn {
    min-width: .96rem;
    background: #FFFFFF;
    border-radius: .06rem;
    font-size: .14rem;
    padding: .1rem .2rem;
    text-align: center;
    line-height: .2rem;
    color: #686868;
    border: 1px solid rgba(104, 104, 104, 0.19);
    cursor: pointer;
  }
  .center {
    width: 16.88rem;
    margin: 0 auto;
    padding: 0.2rem 0;
    .detail-top {
      width: 100%;
      height: .82rem;
      background: #FFFFFF;
      border-radius: .1rem;
      margin-bottom: .1rem;
      padding: 0 .3rem 0 .2rem;
      box-sizing: border-box;
      align-items: center;

      .title {
        font-size: .18rem;
        font-weight: bold;
        color: #F6812F;
        flex: 1;
      }
    }



    button {
      outline: none;
      cursor: pointer;
    }
  }

  .detail-box {
    background: #ffffff;
    border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;
    padding: 0.28rem 0.3rem;

    .device-box {
      .device-img {
        width: 2.96rem;
        height: 2.96rem;
        border-radius: 0.06rem;
        margin-right: 0.2rem;

        img {
          width: 100%;
          height: 100%;
          border-radius: 0.06rem;
        }
      }

      .device-info {
        flex: 1;
        width: 6.61rem;

        .name {
          font-size: 0.2rem;
          color: #333333;
          line-height: 0.23rem;
          font-weight: 500;
        }

        .price-box {
          margin-top: 0.22rem;
          font-size: 0.14rem;
          color: #000000;
          line-height: 0.2rem;
          align-items: center;
          position: relative;

          .price {
            color: #ff4141;
            margin-left: 0.1rem;
          }
        }

        .tips {
          font-size: 0.13rem;
          color: #8f8f8f;
          line-height: 0.33rem;
          margin-top: 0.1rem;
        }

        .info {
          width: 100%;
          border-radius: 0.06rem;
          opacity: 1;
          border: 1px solid #f2f2f2;
          margin-top: 0.16rem;

          .title {
            height: 0.44rem;
            background: #fff3ec;
            padding: 0 0.24rem;

            p {
              font-size: 0.16rem;
              color: #000000;
              line-height: 0.44rem;
              position: relative;

              &::after {
                content: "";
                width: 0.04rem;
                height: 0.14rem;
                background: #ff5400;
                position: absolute;
                top: 0.14rem;
                left: -0.1rem;
              }
            }
          }

          .info-intro {
            flex-wrap: wrap;
            padding: 0.1rem 0;
            background-color: #fffdfc;

            .item {
              width: calc(50% - 0.4rem);
              line-height: 0;
              padding: 0.15rem 0.2rem;

              label {
                display: inline-block;
                min-width: 0.9rem;
                font-size: 0.14rem;
                line-height: 0.24rem;
                color: #aaaaaa;
                margin-right: 0.2rem;
                text-align: right;
              }

              span {
                font-size: 0.14rem;
                line-height: 0.24rem;
                color: #333333;
              }
            }
          }
        }
      }

      // 多设备
      .info {
        width: 60%;
        border: 1px solid #f2f2f2;

        .title {
          height: 40px;
          background: #fff3ec;
          line-height: 40px;
          padding-left: 10px;

          p {
            font-size: 20px;
            color: #000000;
          }
        }

        .info-intro {
          display: flex;
          flex-wrap: wrap;

          .item {
            margin: 30px 10px;
            width: 30%;
            font-size: 15px;

            label {
              color: #afafaf;
            }

            span {
              margin-left: 20px;
              color: #000000;
            }
          }
        }
      }

      .btns {
        flex: 1;
        text-align: right;
        padding-right: 0.22rem;

        .apply {
          width: 1.07rem;
          height: 0.42rem;
          background: #fa6600;
          border-radius: 0.06rem;
          font-size: 0.14rem;
          color: #ffffff;
          line-height: 0.42rem;
          text-align: center;
          border: none;
        }

        .service {
          width: 1.07rem;
          height: 0.42rem;
          background: #ffffff;
          border-radius: 0.06rem;
          border: 1px solid #fa6600;
          font-size: 0.14rem;
          color: #fa6600;
          line-height: 0.42rem;
          text-align: center;
          margin-top: 0.2rem;
        }
      }
    }

    .intro-box {
      margin-top: 0.37rem;

      .title {
        font-size: 0.16rem;
        color: #000000;
      }

      .service-plan {
        margin-top: 0.22rem;
        flex-wrap: wrap;
        padding: 0.15rem 0 0.3rem;
        background: #f9f9f9;
        border-radius: 0.06rem;
        align-items: center;

        .item {
          line-height: 0;
          padding: 0.15rem 0.2rem;

          label {
            display: inline-block;
            min-width: 0.9rem;
            font-size: 0.14rem;
            line-height: 0.24rem;
            color: #aaaaaa;
            margin-right: 0.2rem;
            text-align: right;
          }

          span {
            font-size: 0.14rem;
            line-height: 0.24rem;
            color: #333333;
          }
        }
      }
    }
  }

  .order {
    margin-top: 0.1rem;
    background: #ffffff;
    border-radius: 0.06rem;
    padding: 0.3rem 0 0;

    .order-info {
      padding: 0 0.3rem;

      .left {
        margin-right: 1.52rem;

        .tit1 {
          font-size: 0.16rem;
          color: #000000;
          line-height: 0.2rem;
        }

        .address {
          margin-top: 20px;

          .el-select {
            width: 300px;
          }
        }

        .tit2 {
          margin-top: 70px;
          font-size: 0.16rem;
          color: #000000;
          line-height: 0.2rem;
        }

        .date {
          width: 300px;
          margin: 10px 0;
        }

        .tips {
          font-size: 0.13rem;
          color: #696969;
          margin-top: 0.1rem;
          line-height: 0.2rem;
        }
      }

      .right {
        .tit3 {
          font-size: 0.16rem;
          color: #000000;
          line-height: 0.2rem;

          span {
            font-size: 0.13rem;
            color: #ff5050;
            margin-left: 0.11rem;
          }
        }

        .term-list {
          .item {
            margin-top: 0.25rem;
            min-width: 0.95rem;
            height: 0.51rem;
            background: #fafafa;
            border-radius: 0.04rem;
            border: 1px solid #e7e7e7;
            margin-right: 0.27rem;
            padding: 0.15rem 0.2rem;
            position: relative;
            overflow: hidden;
            cursor: pointer;

            p {
              font-size: 0.16rem;
              color: #b3b3b3;
              line-height: 0.22rem;
            }

            p:nth-of-type(2) {
              font-size: 0.14rem;
              margin-top: 0.08rem;
              line-height: 0.2rem;
            }

            &.active {
              background: #fff5ef;
              border: 1px solid #fec4a2;

              p {
                color: #ff8e4f;
              }

              em {
                display: block;
                position: absolute;
                right: -0.24rem;
                bottom: -0.24rem;

                &:before {
                  content: "";
                  width: 0.48rem;
                  height: 0.48rem;
                  position: absolute;
                  right: 0;
                  bottom: 0;
                  background-color: #ff8e4f;
                  border-radius: 50%;
                }

                &:after {
                  content: "";
                  width: 0.05rem;
                  height: 0.1rem;
                  position: absolute;
                  left: -0.36rem;
                  bottom: 0.3rem;
                  border: 1px solid #fff;
                  border-top-color: transparent;
                  border-left-color: transparent;
                  transform: rotate(45deg);
                  z-index: 10;
                }
              }
            }
          }
        }

        .num-list {
          margin-top: 0.52rem;

          .item {
            width: 2.21rem;
            margin-right: 0.5rem;

            p {
              font-size: 0.14rem;
              color: #000000;

              span {
                color: #ff5050;
              }
            }

            .el-input-number {
              margin-top: 0.12rem;
              width: 2.21rem;
              height: 0.38rem;
              background: #fafafa;
              border-radius: 0.04rem;
              line-height: 0.38rem;

              /deep/.el-input-number__decrease {
                width: 0.59rem;
                height: 0.35rem;
                line-height: 0.35rem;
              }

              /deep/.el-input {
                height: 0.38rem;

                .el-input__inner {
                  height: 0.38rem;
                }
              }
            }
          }
        }
      }
    }

    .bot {
      margin-top: 0.4rem;
      width: calc(100% - 0.6rem);
      padding: 0.22rem 0.3rem 0.17rem;
      border-top: 1px solid #ededed;
      justify-content: flex-end;

      .price {
        font-size: 0.14rem;
        color: #757575;
        line-height: 0.4rem;

        span {
          font-size: 0.24rem;
          color: #ff4a4a;
          margin-left: 0.1rem;
        }
      }

      .apply {
        width: 1.38rem;
        height: 0.4rem;
        background: #686868;
        border: 1px solid #686868;
        border-radius: 0.09rem;
        font-size: 0.14rem;
        color: #ffffff;
        line-height: 0.4rem;
        text-align: center;
        margin-left: 0.35rem;
      }

      .saveOrder {
        width: 1.38rem;
        height: 0.4rem;
        border: 1px solid #686868;
        border-radius: 0.09rem;
        font-size: 0.14rem;
        color: #686868;
        line-height: 0.4rem;
        text-align: center;
        margin-left: 0.32rem;
      }
    }
  }
}

.num-list {
  margin-top: 0.52rem;

  .item {
    width: 2.21rem;
    margin-right: 0.5rem;

    p {
      font-size: 0.14rem;
      color: #000000;

      span {
        color: #ff5050;
      }
    }

    .el-input-number {
      margin-top: 0.12rem;
      width: 2.21rem;
      height: 0.38rem;
      background: #fafafa;
      border-radius: 0.04rem;
      line-height: 0.38rem;

      /deep/.el-input-number__decrease {
        width: 0.59rem;
        height: 0.35rem;
        line-height: 0.35rem;
      }

      /deep/.el-input {
        height: 0.38rem;

        .el-input__inner {
          height: 0.38rem;
        }
      }
    }
  }
}

//单设备下单时，orderId=null
.info-intro2 {
  .item {
    margin: 0 !important;
  }
}
</style>
